<template>
    <div style="width: 100%;">
        <v-toolbar
            flat
            color="white"
        >
            <v-toolbar-title class="grey--text">Tipo Cupones</v-toolbar-title>
            <v-spacer/>
            <v-dialog
                v-model="dialog"
                max-width="600px"
                persistent
            >
                <template v-slot:activator="{ on }">
                    <v-btn
                        color="primary"
                        dark
                        class="mb-2"
                        v-on="on"
                    >
                        Nuevo
                    </v-btn>
                </template>
                <form-tipo-cupon
                    :item="editItem"
                    @close="dialog = false"
                    @save="saveItem"
                />
            </v-dialog>
        </v-toolbar>
        <v-data-table
            :headers="headers"
            :items="tiposCupones"
            :sort-by="['created_at']"
            :sort-desc="[false, true]"
            :options.sync="options"
            class="elevation-1"
            :footer-props="{itemsPerPageOptions : $root.OPTIONS_PER_PAGE_DATATABLE}"
            :loading="loading"
            @update:options="listar"
        >
            <template v-slot:item.imagen_url="{item}">
                <v-avatar
                    tile
                    size="40px"
                    color="grey lighten-4"
                >
                    <img
                        :src="item.img_url"
                        alt="avatar"
                    >
                </v-avatar>
            </template>
            <template v-slot:item.actions="{item}">
                <v-tooltip left>
                    <template v-slot:activator="{on}">
                        <v-icon
                            small
                            class="mr-2"
                            v-on="on"
                            color="light-blue darken-4"
                            @click="editItemId(item.id)"
                        >
                            edit
                        </v-icon>
                    </template>
                    <span>Editar cupón</span>
                </v-tooltip>
                <v-tooltip left>
                    <template v-slot:activator="{on}">
                        <v-icon
                            v-if="item.id !== 1 && item.id !== 2"
                            small
                            v-on="on"
                            color="red"
                            @click="deleteItemConfirm(item)"
                        >
                            delete
                        </v-icon>
                    </template>
                    <span>Eliminar cupón</span>
                </v-tooltip>
            </template>
        </v-data-table>
        <v-dialog
            v-model="dialog_delete"
            max-width="600px"
            persistent
        >
            <v-card>
                <v-card-title>
                    <span class="headline">Eliminar registro</span>
                </v-card-title>
                <v-card-actions>
                    <v-spacer/>
                    <v-btn
                        color="gray darken-1"
                        @click="dialog_delete = false"
                    >
                        No
                    </v-btn>
                    <v-btn
                        color="red darken-1"
                        class="white--text"
                        :loading="loading_delete"
                        :disabled="loading_delete"
                        @click="deleteItem"
                    >
                        Si
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import axios from 'axios';
    import FormTipoCupon from '@components/FormTipoCupon';
    import EventBus from "@/EventBus";

    export default {
        name: "TipoCupones",
        components: {
            FormTipoCupon
        },
        data() {
            return {
                dialog: false,
                dialog_delete: false,
                headers: [
                    {
                        text: '#',
                        align: 'center',
                        value: 'imagen_url',
                        width: '65px',
                        sortable: false,
                    },
                    {
                        text: 'Nombre',
                        align: 'left',
                        sortable: false,
                        value: 'nombre'
                    },
                    {
                        text: 'Opciones',
                        value: 'actions',
                        sortable: false,
                        width: '150px'
                    }
                ],
                tiposCupones: [],
                tiposCuponesTotal: 0,
                itemSelectId: 0,
                itemDelete: null,
                loading: false,
                loading_delete: false,
                options: {
                    descending: true,
                    page: 1,
                    itemsPerPage: this.$root.OPTIONS_PER_PAGE_DATATABLE[0],
                    totalItems: 0
                },
            }
        },
        computed: {
            editItem() {
                if (this.itemSelectId) {
                    return this.tiposCupones.find((item) => item.id === this.itemSelectId)
                } else {
                    return {
                        id: 0,
                        nombre: '',
                    }
                }
            }
        },

        watch: {
            dialog(val) {
                val || this.close()
            }
        },

        created() {
            this.initialize()
        },
        mounted() {
            //this.listar();
        },
        methods: {
            initialize() {
            },
            close() {
                this.dialog = false;
                this.itemSelectId = 0;
            },
            editItemId(itemId) {
                this.itemSelectId = parseInt(itemId);
                this.dialog = true
            },
            deleteItem() {
                this.loading_delete = true;
                axios.delete('api/tipo-cupon/' + this.itemDelete.id)
                    .then((response) => {
                        this.loading_delete = false;
                        let {data} = response;
                        if (data.success) {
                            EventBus.$emit('tugarrafon:show-snackbar',{
                                text_content : data.message,
                                color : 'success'
                            });

                            this.itemDelete = null;
                            this.dialog_delete = false;
                            this.listar();
                        }
                    })
                    .catch((error) => {
                        this.loading_delete = false;
                        if (error.response && error.response.data) {
                            EventBus.$emit('tugarrafon:show-snackbar',{
                                text_content : error.response.data.message,
                                color : 'error'
                            });
                        } else {
                            EventBus.$emit('tugarrafon:show-snackbar',{
                                text_content : 'Error durante la petición',
                                color : error
                            });
                        }
                    })
            },
            deleteItemConfirm(item) {
                this.itemDelete = item;
                this.dialog_delete = true;
            },
            listar() {
                this.loading = true;
                const {sortBy, descending, page, itemsPerPage} = this.options;
                axios.get('/api/tipo-cupon/', {
                    params: {
                        sortBy: sortBy, descending: descending, page: page, rowsPerPage: itemsPerPage,
                        search: this.search
                    }
                })
                    .then((success) => {
                        this.loading = false;
                        let {data} = success;
                        this.tiposCupones = data.data.data;
                        this.options.page = data.data.current_page;
                        this.tiposCuponesTotal = data.data.total;
                    })
            },
            saveItem() {
                this.dialog = false;
                this.listar();
            }
        }
    }
</script>

<style scoped>

</style>
